module.exports = __webpack_public_path__ + "img/OGP_breath.f02756ec.jpg";